import { useEffect, useCallback } from 'react'
import { useIsVirtualMarketer } from './useIsVirtualMarketer'
import { useRootStore } from 'stores/RootStore'
import { useLocation } from 'react-router-dom'
import useResponsiveDesign from './useResponsiveDesign'
import { useCurrentWorkspace } from './useCurrentWorkspace'

export const useAutopilotProvider = () => {
  const { featureFlags } = useRootStore()
  const location = useLocation()
  const currentWorkspace = useCurrentWorkspace()
  const isVirtualMarketer = useIsVirtualMarketer()
  const { isMobile } = useResponsiveDesign()

  const isOnVirtualMarketerOnboarding = location.pathname.includes('/virtual-marketer-onboarding')
  const isOnRegistration = location.pathname.includes('/signup')
  const isOnLogin = location.pathname.includes('/login')
  const isOnboardingPath = isOnVirtualMarketerOnboarding || isOnRegistration || isOnLogin

  const loadFeatureFlags = useCallback(async () => {
    if (!featureFlags.ready) await featureFlags.load()

    if (isOnboardingPath) {
      document.documentElement.setAttribute('data-autopilot-system-redesign', 'on')
    }
  }, [featureFlags, isOnboardingPath])

  useEffect(() => {
    loadFeatureFlags()
  }, [loadFeatureFlags]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (isOnboardingPath || !currentWorkspace) return

    if (isVirtualMarketer) {
      document.documentElement.setAttribute('data-autopilot-system-redesign', 'on')
    } else {
      document.documentElement.setAttribute('data-autopilot-system-redesign', 'off')
    }
  }, [isVirtualMarketer, isOnboardingPath, currentWorkspace])

  useEffect(() => {
    if (isMobile) {
      document.documentElement.setAttribute('data-mobile-onboarding-redesign', 'on')
    } else {
      document.documentElement.setAttribute('data-mobile-onboarding-redesign', 'off')
    }
  }, [isMobile])
}
